const MaterialJSONSchemaFormDefaultProps = {
  uiSchema: null,
  disabled: false,
  customErrors: null,
  noSubmit: false,
  noCaptcha: false
}

export default MaterialJSONSchemaFormDefaultProps
